import { TableSortLabel, TableCell } from '@material-ui/core'
import { useStyles } from '../Styles/styles'
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';

const StyledTableCell = withStyles(() => ({
  root: {
    background: '#7a8697',
    height: 'fit-content',
    padding: 0,
    textAlign: 'center',
    color: 'white',
    fontSize: '1rem',
    borderRight: '2px solid #e3e2e2',
    }
}))(TableCell);

const SortableTableHeader = ({ sortable = true, handleSort, sortLabel, sortedColumn, sortDirection, title, idName, show }) => {
  const classes = useStyles();
  if (show === undefined || show === null) {
    show = true
  }
  return (
    <StyledTableCell onClick={(event) => handleSort && handleSort(event, title, idName, sortLabel)} style={{ display: show ? '' : 'none' }} className={clsx(classes.tableHeader, classes.tableCellBorder)} data-cy="column-header-badge" align="left">
      {sortable && sortedColumn === title ? <TableSortLabel
        onClick={(event) => handleSort(event, title, idName, sortLabel)}
        ref={sortLabel}
        active={sortedColumn === title ? true : false}
        direction={sortDirection}
      >
        {title}
      </TableSortLabel>
        :
        title
      }
    </StyledTableCell>
  );
}

export default SortableTableHeader;